import { Link } from "react-router-dom";
import { Phone, Mail, MapPin, Instagram, Facebook, Twitter } from "lucide-react";

export const Footer = () => (
  <footer className="mt-24 bg-ink text-white">
    <div className="mx-auto max-w-7xl px-5 py-16 lg:px-8">
      <div className="grid gap-10 md:grid-cols-4">
        <div>
          <div className="text-2xl font-semibold">Elite STR</div>
          <div className="overline mt-1 text-white/50">Hosting Co.</div>
          <p className="mt-4 max-w-xs text-sm text-white/60">
            Full-service, technology-driven luxury vacation rental management across Texas and beyond.
          </p>
          <div className="mt-5 flex gap-3">
            {[Instagram, Facebook, Twitter].map((Icon, i) => (
              <a key={i} href="#" className="rounded-full border border-white/15 p-2 transition-colors hover:border-camel hover:text-camel">
                <Icon size={16} strokeWidth={1.5} />
              </a>
            ))}
          </div>
        </div>
        <div>
          <div className="overline mb-4 text-white/40">Guests</div>
          <ul className="space-y-2.5 text-sm text-white/70">
            <li><Link to="/rentals" className="hover:text-camel">Vacation Rentals</Link></li>
            <li><Link to="/reviews" className="hover:text-camel">Reviews</Link></li>
            <li><Link to="/faq" className="hover:text-camel">FAQ</Link></li>
          </ul>
        </div>
        <div>
          <div className="overline mb-4 text-white/40">Owners</div>
          <ul className="space-y-2.5 text-sm text-white/70">
            <li><Link to="/property-management" className="hover:text-camel">Property Management</Link></li>
            <li><Link to="/owner-services" className="hover:text-camel">Revenue Calculator</Link></li>
            <li><Link to="/admin" className="hover:text-camel">Owner Portal</Link></li>
            <li><Link to="/blog" className="hover:text-camel">Owner Education</Link></li>
          </ul>
        </div>
        <div>
          <div className="overline mb-4 text-white/40">Contact</div>
          <ul className="space-y-2.5 text-sm text-white/70">
            <li className="flex items-center gap-2"><Phone size={15} strokeWidth={1.5} /> (210) 274-3556</li>
            <li className="flex items-center gap-2"><Mail size={15} strokeWidth={1.5} /> EliteSTRhostingco@yahoo.com</li>
            <li className="flex items-center gap-2"><MapPin size={15} strokeWidth={1.5} /> San Antonio & Texas Hill Country</li>
          </ul>
        </div>
      </div>
      <div className="mt-12 flex flex-col items-center justify-between gap-3 border-t border-white/10 pt-6 text-xs text-white/40 sm:flex-row">
        <span>© {new Date().getFullYear()} Elite STR Hosting Co. All rights reserved.</span>
        <span>Privacy · Terms · ADA Accessibility</span>
      </div>
    </div>
  </footer>
);
